/// <reference path="../display/Sprite.ts"/>


namespace com.enirva.tween
{
	import Sprite = com.enirva.display.Sprite;

	export class Tween
	{
		/*
		 * フェードイン処理
		 */
		public static fadeIn(spt: Sprite, sp: number = null, cb_func: Function = null, end:number = 1): void
		{
			sp = (sp != null) ? sp : 0.1;

			var thre:number = end - 0.02;

			spt.onEnterFrame = function ():void
			{
				if ((spt.alpha += sp) >= thre)
				{
					spt.alpha = end;
					spt.deleteEnterFrame;

					if (cb_func)
					{
						cb_func();
					}
				}

				spt.update();
			};
		}
	
		/*
		 * フェードアウト処理
		 */
		public static fadeOut(spt: Sprite, sp: number = null, cb_func: Function = null, end:number = 0, isEndDisplayOff:boolean = false): void
		{
			sp = (sp != null) ? sp : 0.1;

			var thre:number = end + 0.02;

			spt.onEnterFrame = function ():void
			{
				if ((spt.alpha -= sp) <= thre)
				{
					spt.alpha = end;
					spt.deleteEnterFrame;

					if (cb_func)
					{
						cb_func();
						if (isEndDisplayOff)
						{
							spt.visible = false;
						}
					}
				}

				spt.update();
			};
		}
	
		/*
		 * モーション処理
		 */
		public static motion(spt: Sprite, prop_array: string[], end_array: number[], sp: number, delay: number = null, threshold: number = null, cb_func: Function = null): void
		{
			var sa: number = 0;
			var curr:any = {};//spt[prop];
			var tmps:any = {};//spt[prop];
			var end: any = {};
			var ln: number = prop_array.length;

			var diff: number = (threshold) ? threshold : 0.002;

			for (var i = 0; i < ln; i++)
			{
				var prop = prop_array[i];
				curr[prop] = spt[prop];
				tmps[prop] = 0;
				end[prop] = end_array[i];
			}

			var flag = true;

			var cc = 0;

			if (delay != null)
			{
				cc = delay;
			}

			var sceneIndex:number = 0;

			spt.onEnterFrame = function ():void
			{
				switch(sceneIndex)
				{
					case 0:
						if (--cc <= 0)
						{
							sceneIndex = 1;
						}
						break;
					case 1:
						sa += sp;
						flag = true;
						for (var prop in curr)
						{
							curr[prop] += tmps[prop] = (end[prop] - curr[prop]) * sa;

							if (Math.abs(tmps[prop]) < diff)
							{
								curr[prop] = end[prop];
							}
							else
							{
								flag = false;
							}

							spt[prop] = curr[prop];
							spt.update();
						}

						if (flag)
						{
							spt.deleteEnterFrame;

							if (cb_func)
							{
								cb_func();
							}
						}
					break;
					default:break;
				}
			};
		}
	

		/*
		 * モーション処理
		 */
		public static motionSpring(spt: Sprite, prop_array: string[], end_array: number[], sp1: number, sp2: number, limit: number = null, delay:number = 0, cb_func: Function = null): void
		{

			var curr:any = {};//spt[prop];
			var tmps: any = {};//spt[prop];
			var end: any = {};
			var ln: number = prop_array.length;

			var lim: number = (limit) ? limit : 0.006;

			for (var i: number = 0; i < ln; i++)
			{
				var prop: string = prop_array[i];
				curr[prop] = spt[prop];
				tmps[prop] = 0;
				end[prop] = end_array[i];
			}

			var flag: boolean = true;

			var sceneIndex:number = 0;

			var cc:number = 0;

			spt.onEnterFrame = function (): void
			{
				switch (sceneIndex) 
				{
					case 0:
						if (++cc >= delay)
						{
							sceneIndex = 1;
						}
						break;
					case 1 :
						flag = true;

						for (var prop in curr)
						{
							curr[prop] += tmps[prop] = (end[prop] - curr[prop]) / sp1 + tmps[prop] * sp2;

							if (Math.abs(tmps[prop]) < lim)
							{
								curr[prop] = end[prop];
							}
							else
							{
								flag = false;
							}

							spt[prop] = curr[prop];
							spt.update();
						}

						if (flag)
						{
							spt.deleteEnterFrame;

							if (cb_func)
							{
								cb_func();
							}
						}
						break;
					default:break;
				}
			};
		}
	

		/*
		 * モーション処理
		 */
		public static delay(spt: Sprite, time: number, cb_func: Function = null): void
		{
			spt.onEnterFrame = function (): void
			{
				if (--time <= 0)
				{
					spt.deleteEnterFrame;

					if (cb_func != null)
					{
						cb_func();
					}
				}
			};
		}


		/*
		 * 明滅するモーション（止める必要あり）
		 */
		public static flash(spt:Sprite, minAlp:number, maxAlp:number, sp:number):void
		{
			var curr:number = spt.alpha;
			var r:number = 0;
			var fric:number = (maxAlp - minAlp) / 2;
			var base:number = minAlp + fric;

			spt.onEnterFrame = function():void
			{
				curr = Math.sin(r += sp) * fric + base;
				spt.alpha = curr;
				spt.update();
			};
		}
	}
}

